import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/order/descending.js
// module id = 3792
// module chunks = 0